import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1 },
  }),
};

const faqs = [
  {
    q: "Is there actually real sand in the soap?",
    a: "Yes. 100% real beach sand. Not synthetic beads, not microplastics — actual sand sourced from natural beaches. That's what gives DermaSand its unmatched exfoliating power.",
  },
  {
    q: "What's the difference between the Split Scrub and Total Scrub?",
    a: "The Split Scrub Bar is dual-action: one side is charcoal and beach sand for scrubbing, the other side has menthol and moisturizers for soothing. The Total Scrub Bar is 100% exfoliation — charcoal and sand throughout the entire bar.",
  },
  {
    q: "Is $8 the final price? Are there hidden fees?",
    a: "What you see is what you pay. $8 per bar, shipping included. No hidden fees, no subscriptions, no surprises.",
  },
  {
    q: "Will the sand scratch or damage my skin?",
    a: "The sand provides a deep exfoliation that removes dead skin cells effectively. If you have extremely sensitive skin, we recommend starting with the Split Scrub Bar so you can use the moisturizing side after exfoliating.",
  },
  {
    q: "How long does one bar last?",
    a: "With regular use (daily showers), a bar typically lasts 3-4 weeks. The sand helps maintain the bar's structure so it doesn't dissolve as fast as regular soap.",
  },
  {
    q: "Can I use it on my face?",
    a: "We recommend using it on the body. For facial use, the Split Scrub Bar's moisturizing side can be used gently, but the sand side is designed for body exfoliation.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-32" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="text-center mb-16"
        >
          <motion.p
            variants={fadeUp}
            custom={0}
            className="font-accent text-sm tracking-[0.25em] uppercase mb-4"
            style={{ color: '#FF5A36' }}
          >
            Questions?
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight"
            style={{ color: '#F0EDE5' }}
          >
            We've Got Answers
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <motion.div key={index} variants={fadeUp} custom={index}>
                <AccordionItem
                  value={`item-${index}`}
                  className="border-b"
                  style={{ borderColor: '#2A2A2A' }}
                  data-testid={`faq-item-${index}`}
                >
                  <AccordionTrigger
                    className="py-6 text-left font-body text-base font-medium hover:no-underline"
                    style={{ color: '#F0EDE5' }}
                    data-testid={`faq-trigger-${index}`}
                  >
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent
                    className="font-body text-sm leading-relaxed pb-6"
                    style={{ color: '#9A9A9A' }}
                    data-testid={`faq-content-${index}`}
                  >
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
